exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-ripple{padding:0!important}.table.vgt-table{font-size:20px}.form-control{border:1px solid #ced4da!important;background-image:none;border-radius:5px!important;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-418e0bae","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/pages/investor/profile.vue
// module id = 555
// module chunks = 0